import { ValueOf } from '@cvent/carina/types/utility';

export const GO_BACK_KEYS = Object.freeze({
  GO_BACK_HREF: 'goBackHref',
  GO_BACK_NAME: 'goBackName',
  GO_BACK_VIEW: 'goBackView',
  GO_BACK_SOURCE_TYPE: 'goBackSourceType',
  GO_BACK_SOURCE_NAME: 'goBackSourceName'
});

export const GO_BACK_SOURCE_TYPE_KEYS = Object.freeze({
  BANNER: 'Banner',
  CATEGORIES: 'Categories',
  EXHIBITOR_LIST: 'Exhibitor List',
  FEATURED_EXHIBITOR: 'Featured Exhibitor',
  FLOOR_PLAN: 'Floor Plan',
  MY_EVENT: 'My Event',
  MY_SCHEDULE: 'My Schedule',
  ON_DEMAND: 'On Demand',
  OTHER: 'Other',
  SESSION_DETAILS: 'Session details',
  SESSION_LIST: 'Session List',
  SPEAKER_DETAILS: 'Speaker details',
  SPEAKER_LIST: 'Speaker List',
  SPONSOR_LIST: 'Sponsor List',
  SPONSORED_SESSION: 'Sponsored Session'
});

export const isRelativeUrl = url => {
  const pattern = /^(?:[a-z]+:)?\/\//i;
  return !pattern.test(url);
};

const removeSessionStorageItems = (...keys) => {
  if (typeof window !== 'undefined') {
    for (const key of keys) {
      sessionStorage.removeItem(key);
    }
  }
};

export type GoBackSourceType = ValueOf<typeof GO_BACK_SOURCE_TYPE_KEYS>;

const isSourceType = (str: string): str is GoBackSourceType => {
  return Object.values(GO_BACK_SOURCE_TYPE_KEYS).some(key => key === str);
};

/**
 *
 * @param {Object} data
 */
export const setSessionStorageData = (data: Record<string, string>): void => {
  if (typeof window !== 'undefined') {
    for (const [key, value] of Object.entries(data)) {
      sessionStorage.setItem(key, value || '');
    }
  }
};

export const getGoBackData = () => {
  const { GO_BACK_HREF, GO_BACK_NAME, GO_BACK_SOURCE_TYPE, GO_BACK_SOURCE_NAME, GO_BACK_VIEW } = GO_BACK_KEYS;

  if (typeof window !== 'undefined') {
    const goBackHref = sessionStorage.getItem(GO_BACK_HREF);
    const goBackSourceType = sessionStorage.getItem(GO_BACK_SOURCE_TYPE);
    return {
      [GO_BACK_HREF]: isRelativeUrl(goBackHref) ? goBackHref : '',
      [GO_BACK_NAME]: sessionStorage.getItem(GO_BACK_NAME),
      [GO_BACK_VIEW]: sessionStorage.getItem(GO_BACK_VIEW),
      [GO_BACK_SOURCE_TYPE]: isSourceType(goBackSourceType) ? goBackSourceType : null,
      [GO_BACK_SOURCE_NAME]: sessionStorage.getItem(GO_BACK_SOURCE_NAME)
    };
  }
  return {
    [GO_BACK_HREF]: null,
    [GO_BACK_NAME]: null,
    [GO_BACK_VIEW]: null,
    [GO_BACK_SOURCE_TYPE]: null,
    [GO_BACK_SOURCE_NAME]: null
  };
};

export const removeGoBackData = () => {
  const { GO_BACK_HREF, GO_BACK_NAME, GO_BACK_SOURCE_TYPE, GO_BACK_SOURCE_NAME, GO_BACK_VIEW } = GO_BACK_KEYS;
  removeSessionStorageItems(GO_BACK_HREF, GO_BACK_NAME, GO_BACK_VIEW, GO_BACK_SOURCE_TYPE, GO_BACK_SOURCE_NAME);
};
